import "./App.css";
import Routers from "./Routers";
import { BrowserRouter, HashRouter } from "react-router-dom";
import Sidebar from "./pages/Sidebar/sidebar";
import AppToast from "./components/appToast";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { onMessage } from "firebase/messaging";
import useNetworkStatus from "./notifications/netChekHook/netCheck";
import { changeStatus, loadingStatus } from "./redux/slice/loaderSlice";
import { updateFcmMessage } from "./redux/slice/toastSlice";
import { messaging } from "./notifications/firebase";
import AppFcmToast from "./components/appFcmToast";
import AppNotification from "./notifications/token-integration";

function App() {
  const { isOnline } = useNetworkStatus();
  const [isActiveNetwork, setActiveNetwork] = useState(false);
  const [isLoading, setLoading] = useState(true);
  const isLoadingShow = useSelector(loadingStatus);

  const dispatch = useDispatch();

  var timer;
  useEffect(() => {
    if (isOnline) {
      checkActiveNetwork();
    } else {
      dispatch(changeStatus(false));
      setActiveNetwork(false);
      setLoading(true);
    }
  }, [isOnline]);

  useEffect(() => {
    onMessage(messaging, (payload) => {
      dispatch(
        updateFcmMessage({
          display: true,
          title: payload?.notification?.title,
          message: payload?.notification?.body,
        })
      );
    });
  }, []);

  const checkActiveNetwork = async () => {
    //setLoading(true);
    dispatch(changeStatus(true));
    fetch("https://www.google.com/", {
      mode: "no-cors",
    })
      .then(() => {
        setActiveNetwork(true);
        setLoading(false);
        dispatch(changeStatus(false));
        clearTimeout(timer);
      })
      .catch(() => {
        setActiveNetwork(false);
        dispatch(changeStatus(false));
        timer = setTimeout(() => {
          checkActiveNetwork();
        }, 5000);
      });
  };
  return (
    <BrowserRouter>
    <AppNotification/>
      <AppToast />
      <AppFcmToast/>
      <Sidebar>
        <Routers />

      </Sidebar>
      
    </BrowserRouter>
  );
}

export default App;
